import { render, staticRenderFns } from "./ClientConnections.vue?vue&type=template&id=2d593432&"
import script from "./ClientConnections.vue?vue&type=script&lang=js&"
export * from "./ClientConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports